import { useRef, useState } from 'react';

import { AddOutlined, DeleteOutline, Settings } from '@mui/icons-material';
import {
  Box,
  ClickAwayListener,
  FormControl,
  IconButton,
  InputLabel,
  ListItemSecondaryAction,
  MenuItem,
  Paper,
  Popover,
  Select,
} from '@mui/material';

import strings from 'constants/index';

import TablePresetsForm from './TablePresetsForm/TablePresetsForm';

type TablePresetsProps = {
  value: string | number;
  columns: any[];
  presets: TablePreset[];
  onSelectPreset: (id: number, presets: TablePreset[]) => void;
  onAddPreset: (data: { name: string; columns: string[] }) => void;
  onRemovePreset: (id: number) => void;
};

const TablePresets = ({
  value,
  onSelectPreset,
  onAddPreset,
  onRemovePreset,
  columns,
  presets,
}: TablePresetsProps) => {
  const [openNewPresetForm, setOpenNewPresetForm] = useState<boolean>(false);
  const [openSettings, setOpenSettings] = useState<boolean>(false);
  const anchorSettingsRef = useRef(null);

  const handleAddPreset = ({ name, columns }) => {
    onAddPreset({ name, columns });
  };

  return (
    <>
      <IconButton
        // sx={{ py: 0, color: '#000000' }}
        sx={{ py: 0 }}
        disableRipple
        onClick={() => setOpenSettings(!openSettings)}
        size="large"
      >
        <Settings ref={anchorSettingsRef} />
      </IconButton>
      <Popover
        anchorEl={anchorSettingsRef.current}
        open={openSettings}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Paper>
          <ClickAwayListener onClickAway={() => setOpenSettings(false)}>
            <Box width={320} padding={2}>
              <Box display="flex">
                <FormControl fullWidth>
                  <InputLabel shrink>{strings.predefined_columns_filters_orders}</InputLabel>
                  <Select
                    variant="standard"
                    MenuProps={{
                      disablePortal: true,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                    }}
                    renderValue={() => presets.find(p => p.id === value)?.name || strings.none}
                    displayEmpty
                    onChange={e => onSelectPreset(e.target.value as number, presets)}
                    value={value}
                  >
                    <MenuItem value="">{strings.none}</MenuItem>
                    {presets.map(({ id, name, editable }: TablePreset) => (
                      <MenuItem key={id} value={id}>
                        {name}
                        {editable && (
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={e => {
                                e.stopPropagation();
                                onRemovePreset(id);
                              }}
                            >
                              <DeleteOutline />
                            </IconButton>
                          </ListItemSecondaryAction>
                        )}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <IconButton onClick={() => setOpenNewPresetForm(!openNewPresetForm)} size="small">
                  <AddOutlined />
                </IconButton>
              </Box>
              {openNewPresetForm && (
                <Box mt={2}>
                  <TablePresetsForm columns={columns} onSubmit={handleAddPreset} />
                </Box>
              )}
            </Box>
          </ClickAwayListener>
        </Paper>
      </Popover>
    </>
  );
};

export default TablePresets;
